import Vue from "vue";
import Router from "vue-router";
import * as constant from "@/utils/constant";
import { capitalized } from "@/utils";

Vue.use(Router);

let newEntityRouteInfo = [];
if (constant.newEntityInfo) {
  for (var key in constant.newEntityInfo) {
    let routerName = capitalized("" + key);
    newEntityRouteInfo.push({
      path: `/${key}`,
      name: `${key}`,
      // component: () => import(/* webpackChunkName: "sxChange" */ `./views/${routerName}.vue`)
      component: () => import(/* webpackChunkName: "sxChange" */ `./views/Common.vue`)
    });
  }
}

const router = new Router({
  linkActiveClass: "tab-item__active",
  mode: "history",
  base: "/ms/",
  routes: [
    {
      path: "/home",
      name: "home",
      component: () => import(/* webpackChunkName: "cake" */ "./views/Home.vue")
    },
    ...newEntityRouteInfo,
    {
      path: "/cake",
      name: "cake",
      component: () => import(/* webpackChunkName: "cake" */ "./views/Cake.vue")
    },
    {
      path: "/sxChange",
      name: "sxChange",
      component: () => import(/* webpackChunkName: "sxChange" */ "./views/sxChange.vue")
    },
    {
      path: "/mart",
      name: "mart",
      component: () => import(/* webpackChunkName: "sxChange" */ "./views/Mart.vue")
    },
    {
      path: "/offline",
      name: "offline",
      component: () => import(/* webpackChunkName: "offline" */ "./views/Offline.vue")
    },

    {
      path: "/cinema",
      name: "cinema",
      component: () =>
        import(/* webpackChunkName: "cinema" */ "./views/Cinema.vue")
    },
    {
      path: "/coupon",
      name: "coupon",
      component: () =>
        import(/* webpackChunkName: "coupon" */ "./views/Coupon.vue")
    },
    {
      path: "/drama",
      name: "drama",
      component: () =>
        import(/* webpackChunkName: "drama" */ "./views/Drama.vue")
    },
    {
      path: "/fitness",
      name: "fitness",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/Fitness.vue")
    },
    {
      path: "/healthy",
      name: "healthy",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/Healthy.vue")
    },
    {
      path: "/life",
      name: "life",
      component: () => import(/* webpackChunkName: "life" */ "./views/Life.vue")
    },
    {
      path: "/book",
      name: "book",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/book.vue")
    },
    {
      path: "/jdyx",
      name: "jdyx",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/JDYX.vue")
    },
    {
      path: "/xmyp",
      name: "xmyp",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/XMYP.vue")
    },
    {
      path: "/movie",
      name: "movie",
      component: () =>
        import(/* webpackChunkName: "movie" */ "./views/Movie.vue")
    },
    {
      path: "/scenery",
      name: "scenery",
      component: () =>
        import(/* webpackChunkName: "scenery" */ "./views/Scenery.vue")
    },
    {
      path: "/spree",
      name: "spree",
      component: () =>
        import(/* webpackChunkName: "spree" */ "./views/Spree.vue")
    },
    {
      path: "/tour",
      name: "tour",
      component: () => import(/* webpackChunkName: "tour" */ "./views/Tour.vue")
    },
    {
      path: "/healthServices",
      name: "healthServices",
      component: () => import(/* webpackChunkName: "tour" */ "./views/HealthServices.vue")
    },
    {
      path: "/oralHealth",
      name: "oralHealth",
      component: () => import(/* webpackChunkName: "tour" */ "./views/OralHealth.vue")
    },
    {
      path: "/examMeal",
      name: "examMeal",
      component: () => import(/* webpackChunkName: "tour" */ "./views/ExamMeal.vue")
    },
    {
      path: "/examOrg",
      name: "examOrg",
      component: () => import(/* webpackChunkName: "tour" */ "./views/ExamOrg.vue")
    },
    {
      path: "/wyyx",
      name: "wyyx",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/Wyyx.vue")
    },
    {
      path: "/listen",
      name: "listen",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/Listen.vue")
    },
    {
      path: "/study",
      name: "study",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/Study.vue")
    },
    {
      path: "/chaoshi",
      name: "chaoshi",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/Chaoshi.vue")
    },
    {
      path: "/hotel",
      name: "hotel",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/Hotel.vue")
    },
    {
      path: "/lxActivity",
      name: "lxActivity",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/LXactivity.vue")
    },
    {
      path: "/lxHotel",
      name: "lxHotel",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/LXhotel.vue")
    },
    {
      path: "/lxScenery",
      name: "lxScenery",
      component: () =>
        import(/* webpackChunkName: "fitness" */ "./views/LXscenery.vue")
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  try {
    router.app.$options.store.commit("setbusinessFrontTagId", '')
  } catch (error) {
    console.log(error)
  }
  if (to.name) {
    window.curPath = to.name;
  }
  next();
});

export default router;

